import gql from 'graphql-tag';

export const CREATE_SPECIFIC_DONATION_MUTATION = gql`
  mutation createSpecificDonation(
    $specificDonationInputDetails: SpecificDonationInput!
  ) {
    createSpecificDonation(
      specificDonationInput: $specificDonationInputDetails
    ) {
      id
      donationType
      donationOrigin
      testatorId
      assetId
      assetType
      assetDisplayName
      monetaryAmount
      beneficiaries {
        id
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
        beneficiaryKinship
        percentage
        alternativeDonation
        alternativeBeneficiary
      }
    }
  }
`;

export const UPDATE_SPECIFIC_DONATION_MUTATION = gql`
  mutation updateSpecificDonation(
    $id: ID!
    $specificDonationInputDetails: SpecificDonationInput!
  ) {
    updateSpecificDonation(
      id: $id
      specificDonationInput: $specificDonationInputDetails
    ) {
      id
      donationType
      donationOrigin
      testatorId
      assetId
      assetType
      assetDisplayName
      monetaryAmount
      beneficiaries {
        id
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
        beneficiaryKinship
        percentage
        alternativeDonation
        alternativeBeneficiary
      }
    }
  }
`;

export const DELETE_SPECIFIC_DONATION_MUTATION = gql`
  mutation deleteSpecificDonation($id: ID!) {
    deleteSpecificDonation(id: $id) {
      id
      donationType
      donationOrigin
      testatorId
      assetId
      assetType
      monetaryAmount
    }
  }
`;
